import { LucideSquareArrowOutUpRight } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'

export default function GotoEndpoint({ content, endpoint, className }: { content: string, endpoint: string, className?: string }) {
    return (
        <Link to={endpoint ?? "/"} className={`text-lg text-primary underline underline-offset-8  hover:text-secondary flex items-center relative gap-4 capitalize w-fit ${className || ''}`}> {content ?? "View My Work"}
            <LucideSquareArrowOutUpRight size="20" />
        </Link>
    )
}
